"use strict";

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { setFeatureName } from '@autoguru/feature-identification';
import { createContext, useContext, useMemo } from 'react';
import { createDataDogAdapter } from '../adapters/DataDogAdapter';
import { initializeDataDogRUM, isDataDogInitialized } from '../datadog';
import { ENV_NAME } from '@autoguru/global-configs';
import { jsx as _jsx } from "react/jsx-runtime";
if (!isDataDogInitialized()) {
  var _GDU_APP_NAME__;
  initializeDataDogRUM({
    service: (_GDU_APP_NAME__ = __GDU_APP_NAME__) === null || _GDU_APP_NAME__ === void 0 ? void 0 : _GDU_APP_NAME__.replace('@autoguru/', ''),
    env: ENV_NAME
  }).catch(error => {
    if (process.env.NODE_ENV !== "production") {
      console.error('[DataDog] Failed to initialise RUM:', error);
    }
  });
}
export const LoggingAgentContext = /*#__PURE__*/createContext(null);
export const LoggingAgentProvider = ({
  children
}) => {
  setFeatureName({
    mfeAppName: __GDU_APP_NAME__
  });
  const agent = useMemo(() => createDataDogAdapter(), []);
  return /*#__PURE__*/_jsx(LoggingAgentContext.Provider, {
    value: agent,
    children: children
  });
};
const isBrowser = typeof window !== 'undefined';
export const useLoggingAgent = () => {
  const agent = useContext(LoggingAgentContext);
  return isBrowser ? agent : null;
};